export const PRIVACY_POLICY = "https://onecareer.co.jp/policy/";
export const COMPANY_SITE = "https://onecareer.co.jp/";
export const PRIVACY_TERMS_FOR_PARTNERS =
  "https://www.onecareer.jp/infos/privacy_terms_for_partners";
export const REQUEST_FORM = "https://onecareer.zendesk.com/hc/ja/requests/new";
